<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <card>
            <button class="btn btn-primary" @click="editProfile">
              <i class="fas fa-edit icon-primary"></i>
            </button>
            <form>
              <div class="col-md-3" style="margin: auto">
                <img
                  :src="'https://jebsenboard.onrender.com/image/User/' + user.image"
                  :alt="user.firstName"
                  class="card-img"
                  style="width: 100%; margin-bottom: 30px; border-radius: 15px;"
                />
              </div>
              <div class="row">
                <div class="col-md-6">
                  <p class="labelProfile">اللاسم الأول</p>
                  <p
                    class="base-input"
                  /><span class="base-input-value">{{ user.firstName }}</span>
                </div>
                <div class="col-md-6">
                  <p class="labelProfile">اللاسم الأخير</p>
                  <p
                    class="base-input"
                  /><span class="base-input-value">{{ user.lastName }}</span>
                </div>
              </div>
              <div class="row">
              <div class="col-md-6">
                <p class="labelProfile">الدور</p>
                <p
                  class="base-input"
                /><span class="base-input-value">{{ user.role }}</span>
              </div>
              <div class="col-md-6">
                <p class="labelProfile">رقم الهاتف</p>
                <p
                  class="base-input"
                /><span class="base-input-value">{{ user.phoneNumber }}</span>
              </div>
            </div>
              <div class="row">
                <div class="col-md-6">
                  <p class="labelProfile">البريد الإلكتروني</p>
                  <p
                    class="base-input"
                  /><span class="base-input-value">{{ user.email }}</span>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "src/Dashboard/SharedComponents/Card.vue";
import jwt_decode from "jwt-decode";
import Axios from "../../Axios";

export default {
  components: {
    Card,
  },
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        role: "",
        phoneNumber: "",
        image: "",
        email: "",
      },
      token: localStorage.getItem("adminToken"),
    };
  },
  methods: {
    editProfile() {
      const decodedToken = jwt_decode(this.token).id;
      this.$router.push("/admin/edit-user/" + decodedToken);
    },
    fetchData() {
      const id = jwt_decode(this.token).id;
      Axios
        .get("/user/" + id)
        .then((response) => {
          this.user = response.data;
          // console.log(response.data);
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },

  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.content {
  background-image: url('../../assets/images/background.png');
  background-size: cover;
}


.card {
  border-radius: 30px;
  box-shadow: 5px 10px 18px #888888;
  background-color: rgba(255, 255, 255, 0.495);
}

.card-img {
  width: 100%;
  margin-bottom: 30px;
  border-radius: 15px;
}

.base-input-value{
  margin-right: 12%;
}


.labelProfile {
  margin-right: 12%;
  margin-top: 25px;
  font-weight: 800;
  margin-bottom: -10px;
}
</style>
